import { Component, Input } from '@angular/core';
import { ConfigurationService } from '@un-fao/lightforms-lib/lightforms-services';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'species-list',
    templateUrl: './species-list.component.html',
    styleUrl: './species-list.component.css',
    standalone: false
})
export class SpeciesListComponent 
{
  @Input() title: string;
  @Input() alphaCodeLabel: string;
  @Input() items: Array<any>;
  @Input() description: string;
  @Input() link: string = "/species/";
  @Input() lowerCaseCode = false;

  public showMore: boolean = false;
  public fisheryUrl: string = environment.fisheryUrl;

  constructor(public configService: ConfigurationService) {}

  getAlphaCode(code: string)
  {
    return this.lowerCaseCode ? code.toLowerCase() : code;
  }
}
